var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "columns",
      class: {
        categorized: _vm.categoriesList.length > 1,
      },
    },
    [
      _vm._l(_vm.filteredCategories, function (category) {
        return [
          _c(
            "div",
            {
              key: category,
              staticClass: "category",
              class: {
                opened: _vm.columnsData[category].opened,
              },
            },
            [
              _c(
                "div",
                { staticClass: "category-title" },
                [
                  _c("column", {
                    attrs: {
                      name: _vm.columnsData[category].fullName,
                      checked: _vm.isCategorySelected(category),
                    },
                    on: {
                      toggle: function ($event) {
                        return _vm.toggleCategory(category, $event)
                      },
                    },
                  }),
                  _c("svg-icon", {
                    staticClass: "category-toggler",
                    attrs: {
                      name: "chevron-top-circled",
                      color: "primary",
                      size: 24,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$set(
                          _vm.columnsData[category],
                          "opened",
                          !_vm.columnsData[category].opened
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _c("transition", { attrs: { name: "slide" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.columnsData[category].opened,
                        expression: "columnsData[category].opened",
                      },
                    ],
                    staticClass: "category-content",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "category-items" },
                      [
                        _vm._l(_vm.categories[category], function (column) {
                          return [
                            _vm.isVisibleColumn(column)
                              ? [
                                  _vm._v(" " + _vm._s(column.disabled) + " "),
                                  _c("column", {
                                    key: column,
                                    attrs: {
                                      disabled:
                                        _vm.columnsData[column].disabled ||
                                        (_vm.blockedColumns &&
                                          _vm.blockedColumns.includes(column)),
                                      name:
                                        _vm.columnsData[column].formatLabel ||
                                        _vm.columnsData[column].fullName,
                                      checked: _vm.isColumnSelected(column),
                                    },
                                    on: {
                                      toggle: function ($event) {
                                        return _vm.toggleColumn(column, $event)
                                      },
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      }),
      !_vm.filteredCategories.length
        ? _c("div", { staticClass: "columns-empty" }, [
            _vm._v("Ничего не найдено"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }